<template>
<div class="hris-page">
  <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">System Settings</span>
      <h1 class="hris-page-title">Users</h1>
      <p class="hris-page-subtitle">Manage system users, their accounts, and module access.</p>
    </div>

    <div class="hris-toolbar">
      <q-btn unelevated class="hris-q-primary" icon="fas fa-plus" label="Add User" @click="addUser"></q-btn>
      <div class="hris-toolbar-spacer"></div>
      <q-input outlined dense color="green" v-model="searchKey" placeholder="Search Employee" style="min-width: 240px;">
        <template v-slot:append>
          <i class="fas fa-search"></i>
        </template>
      </q-input>
    </div>

    <div class="hris-panel">
      <q-table flat dense :data="searchUsers" :columns="columns" row-key="id" :pagination.sync="pagination">
        <template v-slot:body="props">
          <q-tr slot="body" :props="props">
            <q-td key="photo" :props="props">
              <q-avatar size="32px">
                <img src="../../assets/boy-avatar.png">
              </q-avatar>
            </q-td>
            <q-td key="firstname" :props="props">{{ props.row.firstname }}</q-td>
            <q-td key="middlename" :props="props">{{ props.row.middlename }}</q-td>
            <q-td key="lastname" :props="props">{{ props.row.lastname }}</q-td>
            <q-td key="email" :props="props">{{ props.row.email }}</q-td>
            <q-td key="account" :props="props">{{ props.row.account }}</q-td>
            <q-td key="action" :props="props">
              <q-btn round flat dense class="hris-q-ghost" @click="deleteUser(props)">
                <i class="fas fa-user-times"></i>
                <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                  <strong>Delete</strong>
                </q-tooltip>
              </q-btn>
              <q-btn round flat dense class="hris-q-ghost" @click="updateUser(props)">
                <i class="fas fa-user-edit"></i>
                <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                  <strong>Update</strong>
                </q-tooltip>
              </q-btn>
              <q-btn round flat dense class="hris-q-ghost" @click="roleAccess(props)">
                <i class="fa fa-lock" aria-hidden="true"></i>
                <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                  <strong>User Access</strong>
                </q-tooltip>
              </q-btn>
            </q-td>
          </q-tr>
        </template>
        <template v-slot:no-data="">
          <div class="hris-empty full-width">
            No results found.
          </div>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading" style="background: #fff; border-radius: 14px; padding: 32px 44px;">
        <q-spinner color="green" size="40px"></q-spinner>
      </div>
    </q-dialog>

    <q-dialog v-model="deleteDialog" persistent transition-show="scale" transition-hide="scale">
      <div class="hris-modal" style="max-width: 420px;">
        <div class="hris-modal-header">
          <h2 class="hris-modal-title">Are you sure?</h2>
          <q-btn flat round dense class="hris-q-ghost" v-close-popup>
            <i class="fas fa-times"></i>
          </q-btn>
        </div>
        <q-form ref="vForm">
          <div class="hris-modal-body">
            This will permanently delete this user account.
          </div>
          <div class="hris-modal-footer">
            <q-btn flat label="Cancel" class="hris-q-ghost" v-close-popup></q-btn>
            <q-btn unelevated label="Agree" type="submit" class="hris-q-primary" @click="startDeleteUser"></q-btn>
          </div>
        </q-form>
      </div>
    </q-dialog>

    <AddUserAccountModal></AddUserAccountModal>
    <EditUserAccountModal></EditUserAccountModal>
    <UserAccess></UserAccess>
  </div>
</div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';
import AddUserAccountModal from './AddUserAccountModal';
import EditUserAccountModal from './EditUserAccountModal';
import UserAccess from './Role-Access';
export default {
 // name: 'Users',
 components: {
  "AddUserAccountModal": AddUserAccountModal,
  "EditUserAccountModal": EditUserAccountModal,
  "UserAccess": UserAccess
},
data() {
  return {
    spinner: false,
    searchKey: null,
    pagination: {
      rowsPerPage: 10
    },
    columns: [
    { name: 'photo', align: 'left', label: 'Photo', field: '', sortable: true },
    { name: 'firstname', align: 'center', label: 'First Name', field: 'firstname', sortable: true },
    { name: 'middlename', align: 'center', label: 'Middle Name', field: 'middlename', sortable: true },
    { name: 'lastname', align: 'center', label: 'Last Name', field: 'lastname', sortable: true },
    { name: 'email', align: 'center', label: 'Email', field: 'email', sortable: true },
    { name: 'action', align: 'center', label: 'Action', field: '', sortable: true }
    ],
    activateDialog: false,
    addUserDialog : false,
    deleteDialog: false,
    users : [],
    id : null
  }
},
created() {
  let _this = this;
  _this.getUsers();
  _this.eventHub.$on('refreshEmployeeList', _this.getUsers);
},
watch: {

},
computed: {
  searchUsers() {
   // console.log(this.searchKey);
   if (this.searchKey !== null) {
    return this.users.filter(emp => {
      return emp.firstname.toLowerCase().match(this.searchKey) || emp.lastname.toLowerCase().match(this.searchKey) || emp.employee_id.match(this.searchKey)
    });
  } else {
    return this.users
  }
}
},
methods: {
  getUsers: function() {
    this.spinner = true
    axios.create({
      baseURL: this.apiUrl,
      headers: {
        'Authorization': `Bearer ${this.token}`
      }
    })
    .get('/admin/users')
    .then((res) => {
      this.users = res.data.data;
      this.intUser = res.data.data;

      setTimeout(() => {
        this.spinner = false
      }, 500)
    })
  },
  addUser(emp) {
    this.eventHub.$emit('AddUserAccount', { stat: true, employee: emp });
  },
  updateUser(emp) {
    this.eventHub.$emit('EditUserAccount', { stat: true, employee: emp });
  },
  roleAccess(emp) {
    this.eventHub.$emit('UserAccess', { stat: true, employee: emp });
  },
  deleteUser(emp) {
    this.deleteDialog = true;
    this.id  = emp.row.id;
  },
  startDeleteUser(){
    let formData = new FormData();

    formData.append("id", this.id);

    axios.create({
      baseURL : this.apiUrl,
      headers : {'Authorization' : `Bearer ${this.token}`}
    }).post('/admin/delete',formData)
    .then((res) => {

      if(res.data.status){
        this.$q.notify({
          message: 'User successfully deleted.',
          color: 'positive',
          actions: [
        { label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
        ]
      });
        this.getUsers();
        this.deleteDialog = false;
      }else{
        this.$q.notify({
          message: 'Failed to delete a user.',
          color: 'negative',
          actions: [
        { label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
        ]
      })
      }

    });

  }

}
}
</script>
<style lang="css" scoped>
</style>